/* istanbul ignore file */
export const getFallbackTitleStyles = () => ({
  title: {
    minWidth: '232px',
    fontSize: '20px',
    lineHeight: '28px',
    paddingBottom: '10px',
    fontWeight: '600',
  },
});
